WiseMetering.Collection.ZoneAttributeValues = WiseMetering.Collection.extend({
    hasOrganization: true,
    model: WiseMetering.Model.ZoneAttributeValue,
    url: '/zone_attribute_values'
});
